// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import {
  config,
  url
} from '@/store/index'

const state = () => ({
  tableHeaders: [{
    title: 'Стадия договора',
    isSortable: false,
    allActive: false
  },
  {
    title: 'Цвет',
    isSortable: false
  }
  ],
  stages: [],
  modal: {
    active: false,
    updatedId: null,
    name: '',
    color: '#173F7D',
    validation: {
      name: {
        type: null,
        message: ''
      },
      color: {
        type: null,
        message: ''
      }
    }
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  isActiveDelete: false
})

const getters = {
  getContractsStageList: state => state.stages,
  getContractsStageListTableHeaders: state => state.tableHeaders,
  getContractsStageListModal: state => state.modal,
  contractStageListIsLoading: state => state.isLoading,
  getContractsStageListSearchValue: state => state.searchValue,
  getContractsStageListFilter: state => state.filter,
  getContractsStageListPagination: state => state.pagination,
  getContractsStageListResponseModal: state => state.responseModal,
  getContractsStageListResponseModalWithTreaties: state => state.responseModalWithTreaties,
  getContractsStageListActiveDelete: state => state.isActiveDelete
}

const mutations = {
  GET_CONTRACTS_STAGES: (state, stages) => {
    state.stages = stages.data.map(stage => {
      return {
        ...stage,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  TOGGLE_CONTRACTS_STAGE_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.stages.forEach(elem => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  SHOW_CONTRACTS_STAGE_LIST_MODAL: (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedStage = state.stages
        .filter(stage => {
          return stage.id === itemId
        })
        .pop()

      state.modal.updatedId = itemId
      state.modal.name = selectedStage.name
      state.modal.color = selectedStage.color
    }
  },
  SET_CONTRACTS_STAGE_ITEM_NAME: (state, value) => {
    state.modal.name = value
  },
  SET_CONTRACTS_STAGE_ITEM_COLOR: (state, value) => {
    state.modal.color = value
  },
  SET_CONTRACTS_STAGE_ITEM_FULL_NAME: (state, value) => {
    state.modal.fullName = value
  },
  SET_CONTRACTS_STAGE_ITEM_VALIDATION: (state, valid) => {
    if (valid.name) {
      state.modal.validation.name.message = valid.name[0]
      state.modal.validation.name.type = 'error'
    }
    if (valid.color) {
      state.modal.validation.color.message = valid.color[0]
      state.modal.validation.color.type = 'error'
    }
  },
  CLEAR_CONTRACTS_STAGE_MODAL_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = {
          type: null,
          message: ''
        }
        break
      case 'color':
        state.modal.validation.color = {
          type: null,
          message: ''
        }
        break
      default:
        break
    }
  },
  CLOSE_CONTRACTS_STAGE_LIST_MODAL: state => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.color = '#173F7D'
    state.modal.validation.name = {
      id: null,
      message: ''
    }
  },

  // pagination
  SET_CONTRACTS_STAGE_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(
      headers['x-pagination-current-page']
    )
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [
      ...Array(Number(headers['x-pagination-page-count'])).keys()
    ].map(i => ++i)
  },
  RESET_CONTRACTS_STAGE_LIST_CURRENT_PAGE: state => {
    state.pagination.currentPage = 1
  },

  // search
  SET_CONTRACTS_STAGE_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  TOGGLE_CONTRACTS_STAGE_LIST_FILTER: state => {
    state.filter.active = !state.filter.active
  },

  // delete checked items
  DELETE_CONTRACTS_STAGE_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили стадии(й)'
    state.responseModal.type = 'main'
  },
  DELETE_CONTRACTS_STAGE_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении стадии произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },

  DELETE_CONTRACTS_STAGE_LIST_CHECKED_ITEMS_TREATIES_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModalWithTreaties.isActive = true
    state.responseModalWithTreaties.text = `Данные стадии используются в договорах:${listNamesErrorItems}`
    state.tableHeaders.allActive = false
  },
  CLOSE_DELETE_CONTRACTS_STAGE_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  CLOSE_DELETE_CONTRACTS_STAGE_LIST_MODAL_WITH_TREATIES: (state) => {
    state.responseModalWithTreaties.isActive = false
    state.responseModalWithTreaties.text = ''
  },
  TOGGLE_CONTRACTS_STAGE_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.stages.length
    let counter = 0

    state.stages.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_CONTRACTS_STAGE_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.stages.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  RESET_CONTRACTS_STAGE_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.stages.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  // reset store
  RESET_CONTRACTS_STAGE_LIST_STORE: (state) => {
    state.searchValue = ''
    state.pagination.currentPage = 1
  }
}

const actions = {
  getContractsStage ({
    commit,
    state
  }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''

    axios
      .get(`${url}/treaties-stage?expand=treaties&${searchFilter}&take=${currentTake}&page=${currentPage}`, config)
      .then(response => {
        commit('GET_CONTRACTS_STAGES', response.data)
        commit('SET_CONTRACTS_STAGE_LIST_PAGINATION', response.headers)
        state.isLoading = false
      })
      .catch(error => {
        console.log('ошибка получения списка контрагентов', error)
      })
  },
  saveContractsStageItem ({
    commit,
    state,
    dispatch
  }) {
    if (!state.modal.updatedId) {
      const createData = {
        name: state.modal.name,
        color: state.modal.color
      }
      axios
        .post(`${url}/treaties-stage`, createData, config)
        .then(response => {
          commit('CLOSE_CONTRACTS_STAGE_LIST_MODAL')
          dispatch('getContractsStage')
        })
        .catch(error => {
          commit('SET_CONTRACTS_STAGE_ITEM_VALIDATION', error.response.data.errors)
          console.log('Ошибка обновления договора', error.response)
        })
    } else {
      const updateData = {
        name: state.modal.name,
        color: state.modal.color
      }

      axios
        .put(
          `${url}/treaties-stage/${state.modal.updatedId}`,
          updateData,
          config
        )
        .then(response => {
          commit('CLOSE_CONTRACTS_STAGE_LIST_MODAL')
          dispatch('getContractsStage')
        })
        .catch(error => {
          commit('SET_CONTRACTS_STAGE_ITEM_VALIDATION', error.response.data.errors)
          console.log('Ошибка обновления договора', error.response)
        })
    }
  },
  toggleContractsStageListItemControls ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTS_STAGE_LIST_ITEM_CONTROLS', itemId)
  },
  closeContractsStageListItemControls ({ commit }, itemId) {
    commit('CLOSE_CONTRACTS_STAGE_LIST_ITEM_CONTROLS', itemId)
  },
  toggleContractsStageListItemActive ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTS_STAGE_LIST_ITEM_ACTIVE', itemId)
  },
  toggleContractsStageListItemActiveAll ({ commit }) {
    commit('TOGGLE_CONTRACTS_STAGE_LIST_ITEM_ACTIVE_ALL')
  },
  showContractsStageModal ({ commit }, itemId) {
    commit('SHOW_CONTRACTS_STAGE_LIST_MODAL', itemId)
  },
  setContractsStageItemName ({ commit }, value) {
    commit('SET_CONTRACTS_STAGE_ITEM_NAME', value)
  },
  setContractsStageItemColor ({ commit }, value) {
    commit('SET_CONTRACTS_STAGE_ITEM_COLOR', value)
  },
  clearContractsStageModalValidation ({ commit }, inputName) {
    commit('CLEAR_CONTRACTS_STAGE_MODAL_VALIDATION', inputName)
  },
  closeContractsStageModal ({ commit }) {
    commit('CLOSE_CONTRACTS_STAGE_LIST_MODAL')
  },
  removeContractsStage ({ dispatch }, itemId) {
    axios
      .delete(`${url}/treaties-stage/${itemId}`, config)
      .then(response => {
        dispatch('getContractsStage')
      })
      .catch(error => {
        console.log('Ошибка удаления стадии:' + error)
      })
  },

  // pagination
  getContractsStageListPage ({ state, commit }, pageNum) {
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''
    const currentTake = state.pagination.currentTake
    const currentPage = pageNum

    axios.get(`${url}/treaties-stage?${searchFilter}&orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTS_STAGES', response.data)
      commit('SET_CONTRACTS_STAGE_LIST_PAGINATION', response.headers)
      commit('CLOSE_CONTRACTS_STAGE_LIST_PAGE_LIST')
    })
  },
  resetContractsStageListCurrentPage ({ commit }) {
    commit('RESET_CONTRACTS_STAGE_LIST_CURRENT_PAGE')
  },

  // search
  setContractsStageListSearchValue ({ commit, dispatch }, searchValue) {
    commit('SET_CONTRACTS_STAGE_LIST_SEARCH_VALUE', searchValue)
    commit('RESET_CONTRACTS_STAGE_LIST_CURRENT_PAGE')
    dispatch('getContractsStage')
  },

  // delete checked items
  deleteContractsStageListCheckedItems ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    const treatiesItems = []
    state.stages.forEach((e) => {
      if (e.isActive && e.treaties === null) {
        checkedItems.push(e)
      } else if (e.isActive && e.treaties) {
        treatiesItems.push(e)
      }
    })

    if (treatiesItems.length > 0) {
      commit('DELETE_CONTRACTS_STAGE_LIST_CHECKED_ITEMS_TREATIES_ERROR', treatiesItems)

      treatiesItems.forEach((e) => {
        e.isActive = false
      })
    }

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/treaties-stage/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления стадии', error)
        })
      }
    }

    if (checkedItems.length > 0) {
      processMessages(checkedItems).then(() => {
        if (errorItems.length > 0) {
          commit('RESET_CONTRACTS_STAGE_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTS_STAGE_LIST_CHECKED_ITEMS_ERROR', errorItems)
          dispatch('getContractsStage')
        } else {
          commit('RESET_CONTRACTS_STAGE_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTS_STAGE_LIST_CHECKED_ITEMS_SUCCESS')
          dispatch('getContractsStage')
        }
      })
    }
  },
  closeContractsStageListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTS_STAGE_LIST_MODAL')
  },
  closeContractsStageListDeleteModalWithTreaties ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTS_STAGE_LIST_MODAL_WITH_TREATIES')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
